module.exports = __webpack_public_path__ + "assets/images/project/indonesia.jpg?v=56a351eb";